import { BRAND_OVERVIEW_LOCALIZED_BASE_PATH_MAP } from "@/common/static/brands.static";
import { isContentLocale, toContentLocale } from "@/i18n/config";

/**
 * The brand overview path for `locale`, without a leading slash. The map's
 * entries carry their own locale prefix; a routed locale that is not a content
 * language (`en-us`, WHO-5766) gets the words of its content language under
 * its own prefix, so `/en-us/brands` stays on `/en-us`.
 */
export const getBrandOverviewLocalizedPath = (locale?: string) => {
  const path = BRAND_OVERVIEW_LOCALIZED_BASE_PATH_MAP[toContentLocale(locale)];

  if (!locale || isContentLocale(locale)) {
    return path;
  }

  return `${locale}/${path}`;
};
